import type { HttpStateData } from '@/clients/http'

/** The backend's message for a failed request (e.g. "Schema hasn't been registered for model Blog"). */
export const apiErrorMessage = (res: HttpStateData<unknown, { message?: string }>, fallback: string): string => {
  const error = res.error as { data?: { message?: string }; message?: string } | null
  return error?.data?.message || error?.message || fallback
}
